import api from './Api'
import store from '../store'

const route = '/vehicles'
const stats = '/stats/vehicle'

export default {
  // get: params => api().get(`${route}`, { params }),
  get: params => api().get(`${route}`, { params: { ...params, expand: 'dealer,location,movements,todos,currentVehicleLocationEstadoProceso,vehicleLocationEstadoProcesos' } }),
  view: params => api().get(`${route}/${params.id}?expand=dealer,location,movements,movementsWithLocations,todos,currentVehicleLocationEstadoProceso,vehicleLocationEstadoProcesos`),
  viewVehiculoMov: params => api().get(`${route}/${params}`, { params }),
  post: (payload, params) => api().post(`${route}`, payload, { params }),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  delete: payload => api().delete(`${route}/${payload.id}`),
  scanPlateNumber: (payload) => api().post(`${route}/scan/plate`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  scanVin: (payload) => api().post(`${route}/scan/vin`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  downloadTemplate: () => api().get(`${route}/download-template`, {
    responseType: 'blob' // Importante para manejar archivos binarios
  }),
  exportVehicles: () => api().get(`${route}/export-vehicles`, {
    responseType: 'blob' // Importante para manejar archivos binarios
  }),
  importExcel: (formData) => api().post(`${route}/import-excel`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  downloadImportResult: (fullUrl) => {
    // Si la URL es completa (incluye el dominio), usar fetch directo
    if (fullUrl.startsWith('http')) {
      // Obtener el token desde el store
      const token = store.getters.BEARER_TOKEN

      return fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        credentials: 'include'
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.blob().then(blob => ({ data: blob }))
      })
    } else {
      // Si es una ruta relativa, usar el método normal
      return api().get(fullUrl, { responseType: 'blob' })
    }
  },
  getStats: (params = {}) => api().get(`${stats}`, { params }),

  // Métodos para gestión de TO-DO
  assignTodos: (vehicleId, todoIds) => api().post(`${route}/${vehicleId}/assign-todos`, { todo_ids: todoIds }),
  addTodo: (vehicleId, todoId) => api().post(`${route}/${vehicleId}/add-todo`, { todo_id: todoId }),
  removeTodo: (vehicleId, todoId) => api().delete(`${route}/${vehicleId}/remove-todo/${todoId}`),

  // Método para asignar estado de proceso a un vehículo en una ubicación
  assignLocationEstadoProceso: (vehicleId, payload) => {
    // Si el payload es FormData, usar headers apropiados
    const isFormData = payload instanceof FormData
    return api().post(`${route}/${vehicleId}/assign-location-estado-proceso`, payload, {
      headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : undefined
    })
  },

  // Métodos para documentos de estado de proceso
  addEstadoProcesoDocuments: (estadoProcesoId, payload) => {
    return api().post(`/estado-proceso/${estadoProcesoId}/docs`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  removeEstadoProcesoDocument: (estadoProcesoId, docId) => {
    return api().delete(`/estado-proceso/${estadoProcesoId}/docs/${docId}`)
  }
}
